import { defaultCoordinate } from '@/constants'
import { measureText } from '@/helpers/canvasHelpers'
import typedStore from '@/store/typedStore'
import { Coordinate2D, Dimensions, NodeData, Path, StoryKeys } from '@/types'

export class HeaderMetadata {
  path: Path
  selected: boolean = false
  private _node: NodeData
  private _onPositionChanged: (coordinates: Coordinate2D) => void = () => {}
  private _position: Coordinate2D = defaultCoordinate()

  constructor(node: NodeData) {
    this.path = new Path({ path: node.path })
    this._node = node
  }

  get position() {
    return this._position
  }

  set position(value: Coordinate2D) {
    this._position = value
    this._onPositionChanged(value)
  }

  get name() {
    let label: string | null | undefined = null
    if (this.path.level === 1) {
      label = this._node?.config?.label
    }
    return label ?? this.path.name
  }

  get fontSize() {
    return 40
  }

  get fontFamily() {
    return 'Segoe UI'
  }

  get padding() {
    return 50
  }

  get size(): Dimensions {
    const metrics = measureText(this.name, this.fontSize, this.fontFamily)
    return {
      width: metrics.width + this.padding,
      height: this.fontSize + this.padding,
    }
  }

  get colourPath() {
    return this.path.level1
  }

  get fontColour() {
    return typedStore.activeVisualisation.visualisationStore.app.tabFontColor(
      this.colourPath,
      StoryKeys.SIDEBAR_BOT,
    )
  }

  get storyColour() {
    return (
      typedStore.activeVisualisation.visualisationStore.entities.nodes.colour(this.colourPath) ??
      'white'
    )
  }

  // When nodes are initially updated in the node store they are actually
  // replaced, due to this we need to be able to update the node that is
  // referenced here
  updateNode(node: NodeData) {
    this._node = node
  }

  onPositionChanged(callback: (coordinates: Coordinate2D) => void) {
    this._onPositionChanged = callback
  }
}
